import React from 'react'

export function MatchingAnswerForm({ q, answer, onChange }) {
  const left = Array.isArray(q.payload?.left) ? q.payload.left : []
  const right = Array.isArray(q.payload?.right) ? q.payload.right : []

  // Normalize existing pairs to align with left items
  const rawPairs = Array.isArray(answer?.pairs) ? answer.pairs : []
  const pairs = left.map((_, idx) => {
    const existing = rawPairs.find(p => typeof p?.leftIndex === 'number' && p.leftIndex === idx)
    if (existing) return existing
    return { leftIndex: idx, rightIndex: null }
  })

  function updatePair(leftIndex, rightIndex) {
    const next = pairs.map(p => (p.leftIndex === leftIndex ? { ...p, rightIndex } : p))
    onChange(q, { pairs: next })
  }

  if (!left.length || !right.length) {
    return (
      <div style={{ fontSize: 13, color: '#6b7280' }}>
        لا يمكن عرض سؤال المزاوجة لأن بيانات العمودين غير مكتملة.
      </div>
    )
  }

  return (
    <div style={{ display: 'grid', gap: 8 }}>
      {pairs.map((pair, idx) => {
        const leftLabel = left[pair.leftIndex] ?? left[idx] ?? `العنصر ${idx + 1}`
        const currentRightIndex = typeof pair.rightIndex === 'number' ? pair.rightIndex : ''
        return (
          <div
            key={pair.leftIndex ?? idx}
            style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}
          >
            <div style={{ minWidth: 28, color: '#111827', fontWeight: 700 }}>{idx + 1}-</div>
            <div
              style={{ flex: 1, fontSize: 13, color: '#111827', whiteSpace: 'pre-wrap', lineHeight: 1.6 }}
            >
              {leftLabel}
            </div>
            <select
              value={currentRightIndex}
              onChange={e => {
                const val = e.target.value
                const nextIndex = val === '' ? null : Number(val)
                updatePair(pair.leftIndex, Number.isNaN(nextIndex) ? null : nextIndex)
              }}
              style={{ padding: '6px 8px', borderRadius: 8, border: '1px solid #e5e7eb', fontSize: 13 }}
            >
              <option value="">اختر المطابقة</option>
              {right.map((r, rIdx) => (
                <option key={rIdx} value={rIdx}>
                  {r || `العنصر ${rIdx + 1}`}
                </option>
              ))}
            </select>
          </div>
        )
      })}
    </div>
  )
}
